/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Redirect } from 'react-router'

/**
 *     Import
 *     - Components
 */
import Container from '../../../common/Container/Container'
import HeaderContainer from '../../../common/HeaderContainer/HeaderContainer'
import VariantBlock from './VariantBlock'
import { EditIcon } from '../../../../images/icons/Edit/Edit'
import PopUp from '../../../common/PopUp/PopUp'
import DatePicker from '../../../common/DatePicker/DatePicker'
import { currency, symbol, settlementBasisCalc } from '../../../common/CurrencyFormat'

/**
 *     Import
 *     - Styles
 */
import '../styles/Quote.css'

export default class ViewQuote extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            bindPopUp: {
                show: false,
                quoteId: '',
                quoteVariationId: '',
                businessName: '',
                quoteRef: '',
                inceptionDate: '',
                printDate: '',
                premium: Number,
                commission: '',
                excess: Number,
            },
            bindPopUpSendShow: false,
            viewQuotePopUp: false,
            viewIssuePopUp: false,
            boundPopupQuoteId: null,
            boundPopup: false,
            boundBind: false,
            bespokePolicyId: '',
            issuePopupError: false,
            issueErrorList: '',
            downloadQuote: false,
        }
    }
    componentDidMount() {
        this.props.fetchLocations(this.props.match.params.quoteId)
    }

    componentWillMount() {
        this.props.getQuoteSingle(this.props.match.params.quoteId)
    }

    handleEdit = () => {
        this.setState({ viewQuotePopUp: true })
    }

    /**
     * Handle the action of binding the quote from the PopUp
     *
     * @param {*} quoteId
     * @param {*} quoteVariationId
     * @memberof Clients
     */
    handleBind = (quoteId: any, quoteVariationId: any, inceptionDate: any, bespokePolicyId: any) => {

        this.props.bindQuoteVariation(quoteId, quoteVariationId, inceptionDate, bespokePolicyId).then((Response) => {

            if (Response.value) {
                this.setState({
                    boundBind: true,
                    boundPopupQuoteId: Response.value.policy.id,
                })
            }
        })
        this.setState({ bindPopUpSendShow: false })
        // this.setState(
        //     {
        //         bindPopUp: {
        //             show: false,
        //             quoteId: '',
        //             quoteVariationId: '',
        //             businessName: '',
        //             quoteRef: '',
        //             inceptionDate: '',
        //             printDate: '',
        //             premium: Number,
        //             commission: '',
        //             excess: Number,
        //         },
        //         bindPopUpSendShow: false,
        //         quoteVariationId,
        //     }
        // )
    }

    printDate = () => {
        return this.state.bindPopUp.printDate
    }

    // /**
    //  * Handle the action of binding the quote from the PopUp
    //  *
    //  * @param {*} quoteId
    //  * @param {*} quoteVariationId
    //  * @memberof Clients
    //  */
    // handleBind = (quoteId: any, quoteVariationId: any) => {
    //     this.props.bindQuoteVariation(quoteId, quoteVariationId)
    //     this.setState({ bindPopUp: { ...this.state.bindPopUp, show: false } })
    // }

    handleEndRoute = (quoteVariationId: any) => {
        this.setState(
            {
                bindPopUp: {
                    show: false,
                    quoteId: '',
                    quoteVariationId: '',
                    businessName: '',
                    quoteRef: '',
                    inceptionDate: '',
                    printDate: '',
                    premium: Number,
                    commission: '',
                    excess: Number,
                },
                bindPopUpSendShow: false,
                quoteVariationId,
                boundPopup: true,
            }
        )
    }

    handleInput = (event) => {
        this.setState({ bespokePolicyId: event.target.value })
    }

    issueViewQuoteVariation = (quoteId, id) => {
        this.props.issueViewQuoteVariation(quoteId, id).then((response) => {
            if (response.success !== false) {
                this.setState({ viewIssuePopUp: true })
            }
        }).catch((response) => {
            if (response.success === false || response.error) {
                this.setState({
                    issuePopupError: true,
                    issueErrorList: response.error,
                })
            }
        })
    }

    handleReissueQuote = (quoteId, id) => {
        this.props.handleReissueQuote(quoteId, id).then((response) => {
            if (response.success !== false) {
                this.setState({ downloadQuote: true })
            }
        }).catch((response) => {
            if (response.success === false || response.error) {
                this.setState({
                    issuePopupError: true,
                    issueErrorList: response.error,
                })
            }
        })
    }

    render() {
        const { isCollectors, isDealersStock, isMuseums } = this.props

        if (!this.props.quote.done) {
            return (<div />)
        }

        if (this.props.step05Bind.done && !this.props.step05Bind.error && this.state.boundPopup) {
            return <Redirect to={`/quote/${this.state.boundPopupQuoteId}/summary`} />
        }

        return (
            <div className="quote quote--view">
                {
                    (this.props.step05Bind.error) ?
                        < PopUp
                            title="Something went wrong"
                            buttonText="Close"
                            action={() => {
                                this.props.step05Bind.error = null
                                this.props.step05Bind.done = null
                                this.forceUpdate()
                            }}
                        >
                            {this.props.step05Bind.error.error}
                        </ PopUp>
                        :
                        null
                }
                {this.state.issuePopupError ? (
                    <PopUp
                        title={`Something went wrong`}
                        buttonText={`Close`}
                        action={() => {
                            this.setState({ boundTitle: '', issuePopupError: false, issueErrorList: '' })
                        }}
                    >
                        {(this.state.issueErrorList).toLowerCase()}
                    </ PopUp>
                ) : null}
                {this.state.boundBind ? (
                    <PopUp
                        title="Quote Bound"
                        buttonText={`Quote Bound`}
                        action={() => this.handleEndRoute(this.state.bindPopUp.quoteVariationId)}
                    >
                        The quote has been bound
                    </ PopUp>
                ) : null}
                {(this.state.viewQuotePopUp) ?
                    <PopUp
                        title="Do you wish to edit this quote?"
                        action={(

                        ) => {
                            this.props.confirmEditQuote(this.props.match.params.quoteId)
                            this.props.history.push('/clients/quotes/edit/' + this.props.match.params.quoteId)
                        }}
                        buttonText="Edit quote"
                        secondaryAction={() => { this.setState({ viewQuotePopUp: false }) }}
                        secondaryButtonText="Cancel"
                    >
                        If you edit this quote the other preview quotes you have issued for this client will be revoked.
                        Do you wish to continue?
                    </PopUp>
                    : null}
                {(this.state.viewIssuePopUp) ?
                    <PopUp
                        title="Quote issued"
                        action={() => {
                            this.setState({ viewIssuePopUp: false })
                        }}
                        buttonText="OK"

                    >
                        The quote has been issued
                    </PopUp>
                    : null}

                {(this.state.downloadQuote) ?
                    <PopUp
                        title="Download Quote"
                        action={() => {
                            this.setState({ downloadQuote: false })
                        }}
                        buttonText="OK"

                    >
                        Thank you for issuing the quote; this will be emailed to you.
                    </PopUp>
                    : null}

                {
                    this.state.bindPopUp.show &&
                    < PopUp
                        title="Select Inception Date"
                        buttonText="Cancel"
                        action={
                            () =>
                                this.setState(
                                    {
                                        bindPopUp: {
                                            show: false,
                                            quoteId: '',
                                            quoteVariationId: '',
                                            businessName: '',
                                            quoteRef: '',
                                            inceptionDate: '',
                                            printDate: '',
                                            premium: Number,
                                            commission: '',
                                            excess: Number,
                                        },
                                    }
                                )
                        }
                    >
                        <div className="quotePreview__box">
                            {/* {(isCollectors || isMuseums || isDealersStock) && */}
                                <div className="quotePreview__row">
                                    <div className="text">
                                        Bespoke Policy ID:
                                    </div>
                                    <div className="quotePreview__row__inception_date">
                                        <input
                                            type="text"
                                            name="bespokePolicyId"
                                            placeholder="Bespoke Policy ID"
                                            onChange={this.handleInput}
                                        />
                                    </div>
                                </div>
                            {/* } */}
                            <div className="quotePreview__row">
                                <div className="text">
                                    Please enter the inception date:
                                </div>
                                <div className="quotePreview__row__inception_date">
                                    <DatePicker
                                        placeholder="Policy inception date"
                                        step05inceptionDate={this.printDate()}
                                        onChange={(inceptionDate) => this.setState(
                                            {
                                                bindPopUp:
                                                    { ...this.state.bindPopUp, inceptionDate, show: false },
                                                bindPopUpSendShow: true,
                                            }

                                        )}
                                        onFocus={() => null}
                                    />
                                </div>
                            </div>
                        </div>
                    </PopUp >
                }

                {
                    (this.state.bindPopUpSendShow) ?
                        < PopUp
                            title="Do you want to bind this quote?"
                            buttonText="Bind"
                            action={
                                () => {
                                    this.handleBind(
                                        this.state.bindPopUp.quoteId,
                                        this.state.bindPopUp.quoteVariationId,
                                        this.state.bindPopUp.inceptionDate,
                                        this.state.bespokePolicyId
                                    )
                                }
                            }
                            numberButtons={2}
                            secondaryButtonText="Cancel"
                            secondaryAction={
                                () =>
                                    this.setState(
                                        {
                                            bindPopUp: {
                                                show: false,
                                                quoteId: '',
                                                quoteVariationId: '',
                                                businessName: '',
                                                quoteRef: '',
                                                inceptionDate: '',
                                                printDate: '',
                                                premium: Number,
                                                commission: '',
                                                excess: Number,
                                            },
                                            bindPopUpSendShow: false,
                                        }
                                    )
                            }
                        >
                            <div className="quotePreview__box">
                                <div className="quotePreview__header">
                                    <div className="quotePreview__header__title">
                                        {this.state.bindPopUp.businessName}
                                    </div>
                                    <div className="quotePreview__header__subtitle">
                                        {this.state.bindPopUp.policyName || 'Art and Antiques Dealer'} Policy
                                    </div>
                                    <div className="quotePreview__header__policyInfo">
                                        Policy no. <span>{this.state.bindPopUp.quoteRef}</span>
                                    </div>
                                </div>

                                <div className="quotePreview__row">
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Inception date</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.inceptionDate}</span>
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Date quoted</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.printDate}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="quotePreview__row">
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Premium</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{currency(this.state.bindPopUp.premium)}</span> inc.IPT
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Your commission</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.commission}%</span>
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Excess</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{symbol()} {this.state.bindPopUp.excess}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </PopUp > :
                        null
                }

                <HeaderContainer
                    className="quote__header"
                    fullwidth={true}
                    titles={['Quote Details']}
                    back={true}
                    backAction={() => this.props.history.goBack()}
                >
                    <div className="quote__editBtn" onClick={this.handleEdit}>
                        <EditIcon />
                        <span>Edit quote</span>
                    </div>
                    <div className="quote__validDays text_r_aln">
                        Quote valid for {this.props.quote.response.daysValid} days
                    </div>
                </HeaderContainer>

                {
                    (this.props.quote.response.subjectivities.length ?
                        <Container className="subjectivities" fullwidth={false}>
                            <div>
                                <div className="subjectivities__header">
                                    <span>Subjectivity warning: </span>
                                    This quote is subject to the following conditions
                                </div>
                                <div className="subjectivities__content">
                                    <div className="subjectivities__reason">

                                        {this.props.quote.response.subjectivities.map((subjectivity, index) => (
                                            <div key={index}>
                                                <span>{subjectivity.title}: </span>{subjectivity.description}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </Container>
                        :
                        null
                    )
                }

                <Container className="quote__view" fullwidth={false}>
                    <div className="quote__view__infoblock">

                        <div className="quote__view__header">
                            <div>{this.props.quote.response.clientName}</div>
                            {this.props.quote.response.policyName || 'Art and Antiques Dealer'} Policy
                        </div>

                        <div className="quote__view__container">
                            <div className="quote__view__block quote__view__block--small">
                                <div>Inception date</div>
                                <span>{this.props.quote.response.inceptionDate}</span>
                            </div>

                            <div className="quote__view__block quote__view__block--small">
                                <div>Date quoted</div>
                                <span>{this.props.quote.response.quotedDate}</span>
                            </div>

                            <div className="quote__view__block quote__view__block--small">
                                <div>{(this.props.quote.response.policyName === 'Collectors' || isCollectors) ?
                                    'Collection sum insured' : isMuseums ? 'Total Exhibits Sum Insured' :
                                        `Total ${isDealersStock ? 'dealers stock' : 'stock'} sum insured`}
                                </div>
                                <span>{currency(this.props.quote.response.totalSumInsured)}</span>
                            </div>
                            {(this.props.quote.response.policyName !== 'Collectors' && !isCollectors && !isMuseums) ?
                                <div className="quote__view__block quote__view__block--small">
                                    <div>Settlement basis</div>
                                    <span>
                                        {(this.props.quote.response.settlementBasis < 1 ?
                                            'Selling price' :
                                            'Cost price')
                                        } {
                                            settlementBasisCalc(this.props.quote.response.settlementBasis)
                                        }%
                                    </span>
                                </div> : null}
                        </div>
                    </div>

                    {this.props.quote.response.quoteVariations.map((item, index) => (
                        <VariantBlock
                            key={'variation' + index}
                            index={index}
                            variation={item}
                            quoteId={this.props.match.params.quoteId}
                            isCollectors={(this.props.quote.response.policyName === 'Collectors' || isCollectors) ?
                                true : false}
                            isMuseums={isMuseums}
                            isDealersStock={isDealersStock}
                            riskLocations={(this.props.quote.response.policyName === 'Collectors' ||
                                isCollectors || isMuseums) ?
                                this.props.riskLocations : null}
                            handleReissueQuote={(quoteId, id) => {
                                this.handleReissueQuote(quoteId, id)
                            }}
                            issueViewQuoteVariation={(quoteId, id) => {
                                this.issueViewQuoteVariation(quoteId, id)
                            }}
                            bindQuoteVariation={
                                (variation) => {
                                    this.setState(
                                        {
                                            bindPopUp: {
                                                show: true,
                                                quoteId: this.props.quote.response.id,
                                                quoteVariationId: variation.id,
                                                businessName: this.props.quote.response.clientName,
                                                quoteRef: variation.quoteRef,
                                                inceptionDate: this.props.quote.response.inceptionDate,
                                                printDate: this.props.quote.response.quotedDate,
                                                premium: variation.premium,
                                                commission: variation.commission,
                                                excess: variation.excess,
                                                policyName: this.props.quote.response.policyName,
                                            },
                                        }
                                    )
                                }
                            }
                        />
                    ))}
                </Container>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/ViewQuote/ViewQuote.tsx